<template>
    <div :id="mapId" :style="{ width: width, height: height, borderRadius: '5px'}" class="naver-map"></div>
</template>

<!-- 모바일 -->
<style scoped>
.naver-map {
  margin-top: 40px;
}

@media (max-width: 1024px) {
  .naver-map {
    width: 100% !important;
    height: auto !important;
    min-height: 200px;
    display: block;
    background-color: #dfdfdf;
    margin-top: 12px;
  }  
}
</style>

<script>
  export default {
    name: "NaverMap",
    props: {
      latitude: {
        type: Number,
        required: true,
      },
      longitude: {
        type: Number,
        required: true,
      },
      width: {
        type : String,
        required: true,
      },
      height: {
        type : String,
        required: true,
      },
      mapKey: {
        type: Number,
        required: true,
      },
      zoom: {
        type: Number,
        default: 17
      }
    },
    data(){
        return{
            mapId: `map-${this.mapKey}`
        }
    },
    mounted() {
        this.loadNaverMapScript()
            .then(() => this.initMap())
            .catch((err) => {
                console.error("네이버 지도 로딩 실패:", err);
                alert("네이버 지도 인증 실패. 클라이언트 ID와 도메인을 확인하세요.");
            });
    },
    methods: {
      loadNaverMapScript() {  
          return new Promise((resolve, reject) => {
              if (window.naver && window.naver.maps) {
                  resolve();
              } else {
                  const script = document.createElement("script");
                  const clientId = process.env.NAVER_MAP_CLIENT_ID;
                  script.src = `https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=${clientId.toString()}`;
                  script.async = true;

                  window.navermap_authFailure = () => {
                    alert("네이버 지도 client id 인증 실패");
                    reject(new Error("Client Id 인증 실패"));
                    this.$router.push("/main");
                  }

                  script.onload = () => {
                      if (window.naver && window.naver.maps) {
                          resolve();
                      } else {
                          reject(new Error("네이버 지도 API 로드 실패: window.naver.maps 없음"));
                      }
                  };

                  script.onerror = () =>
                      reject(new Error("지도 API 스크립트 로딩 실패"));
                      document.head.appendChild(script);
                  }
          });
      },
  
      // 지도
      initMap() {
        const mapOptions = {
          center: new naver.maps.LatLng(this.latitude, this.longitude),
          zoom: this.zoom,
        };
  
        const map = new naver.maps.Map(this.mapId, mapOptions);
  
        // 마커 추가
        new naver.maps.Marker({
          position: new naver.maps.LatLng(this.latitude, this.longitude),
          map: map,
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/sub03/NaverMap.vue